/**
 * Ficmoon 品牌 - Book 页面配置
 */
import { commonTexts } from './common'
import type { BookPageConfig } from './types'

/**
 * Ficmoon 品牌特定主题配置
 * 注意: 大部分颜色应使用 UnoCSS 主题变量,这里只保留品牌特有的配置
 */
export const theme = {
  // 引用装饰线颜色 (Ficmoon 使用橙色调,基于主色)
  quoteColor: 'rgba(252, 84, 47, 0.3)',
  // 目录弹窗中锁图标的颜色 (Ficmoon 使用白色)
  tocLockColor: '#ffffff',
} as const

export const bookConfig: BookPageConfig = {
  theme,
  texts: commonTexts,
}
